import line from 'daisy-chart/src/layouts/line';
import {timeDays} from 'd3-time';

var dates = timeDays(new Date(2016, 0, 1), new Date(2018, 0, 1), 1);
var dataLength = 731;
var dataset = [];
var i, j;
for (i = 0; i < dataLength; i ++) {
  for (j = 0; j < 3; j ++) {
    dataset.push({category: j, date: dates[i%dates.length], value: Math.random() * 1000, num : dates[i%dates.length].getMonth()});
  }
  
}

line().data(dataset)
  .container('#daisy-example')
  .name('line')
  .dimensions([
    {field: 'date', order: 'descending', interval: 'week', format: '%Y년%m월%d일'}, 
    {field: 'category', order: 'descending'}
  ])
  .measures([{field: 'value', op:'mean'}])
  .axis('x').axis('y')
  .shape('area')
  .stacked(true)
  .zoom('brush')
  .legend(true)
  .multiTooltip(true)
  .render();
    


// WEBPACK FOOTER //
// ./js/examples/brushLine.js